import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";
import { defaultListMessages } from "../shared/crud/list";
import { Message } from "../shared/i18n";
import { EngineGuestDataEntity } from "./domain/engineGuestData.entity";

const formMessages: Record<keyof EngineGuestDataEntity, Message> = defineMessages({
  id: {
    id: "engineGuestDataForm.label.id",
    defaultMessage: "engineGuestDataForm.label.id",
  },
  bookingFormCountry: {
    id: "engineGuestDataForm.label.bookingFormCountry",
    defaultMessage: "Request country",
  },
  bookingFormPhone: {
    id: "engineGuestDataForm.label.bookingFormPhone",
    defaultMessage: "Request phone",
  },
  bookingFormDni: {
    id: "engineGuestDataForm.label.bookingFormDni",
    defaultMessage: "Request DNI",
  },
  bookingFormAddress: {
    id: "engineGuestDataForm.label.bookingFormAddress",
    defaultMessage: "Request address",
  },
  bookingFormRepeatEmail: {
    id: "engineGuestDataForm.label.bookingFormRepeatEmail",
    defaultMessage: "Request repeat email",
  },
  bookingFormArrivalTime: {
    id: "engineGuestDataForm.label.bookingFormArrivalTime",
    defaultMessage: "Request arrival time",
  },
  bookingFormNewsletter: {
    id: "engineGuestDataForm.label.bookingFormNewsletter",
    defaultMessage: "Solicitar recibir oferta",
  },
  bookingFormPostalCode: {
    id: "engineGuestDataForm.label.bookingFormPostalCode",
    defaultMessage: "Request postal code",
  },
  bookingFormCity: {
    id: "engineGuestDataForm.label.bookingFormCity",
    defaultMessage: "Request city",
  },
  bookingFormBirthDate: {
    id: "engineGuestDataForm.label.bookingFormBirthDate",
    defaultMessage: "Request date of birth",
  },
  bookingFormAllGuestsData: {
    id: "engineGuestDataForm.label.bookingFormAllGuestsData",
    defaultMessage: "Request the details of every guest",
  },
});
export const messages = {
  ...defaultFormMessages,
  ...defaultListMessages,
  ...formMessages,
  ...defineMessages({
    entityName: {
      id: "engineGuestData.entityName",
      defaultMessage: "Guest data",
    },
  }),
};
